module.exports = __webpack_public_path__ + "static/media/stockhausen_haum_01.5b5311ed.jpg";